import { useShouldShowPrompt } from '../../releaseprompt/hooks/useShouldShowPrompt';
import { usePushNotificationState } from './usePushNotificationState';
import {
  PUSH_NOTIFICATIONS_GRANTED,
  PUSH_NOTIFICATIONS_UNDETERMINED,
  PUSH_NOTIFICATIONS_DENIED,
  pushNotificationsConfig,
} from '../../commons/config';

export type PushNotificationPromptType = 'initial' | 'denied';

export type ShouldShowPushNotification = {
  markReminded: () => void;
  promptType: PushNotificationPromptType;
};

export const useShouldShowPushNotificationPrompt: () => ShouldShowPushNotification | null = () => {
  const { markReminded } = useShouldShowPrompt('PushNotifications');
  const { state } = usePushNotificationState();

  if (!markReminded || !pushNotificationsConfig.isEnabled || !state) {
    return null;
  }

  if (state.status === PUSH_NOTIFICATIONS_DENIED) {
    return { markReminded, promptType: 'denied' };
  }

  if (
    state.status === PUSH_NOTIFICATIONS_UNDETERMINED ||
    (state.status === PUSH_NOTIFICATIONS_GRANTED && !state.expoPushToken)
  ) {
    return { markReminded, promptType: 'initial' };
  }

  return null;
};
